import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import { AuthService } from 'modules/auth';
import { NotificationStore as Store } from 'modules/notification';

import {
  EVENT_TYPE,
  FIREBASE_CONFIG,
  MAX_NOTIFICATION_PER_PAGE,
  NOTIFICATION_TYPE
} from './constants';

import Request from '@hotmart/request';

class NotificationService {
  // #region setup
  async init() {
    if (!this.authToken) {
      if (!AuthService.areaCode) {
        await AuthService.refreshAccountData();
      }
      this.areaCode = AuthService.areaCode;
      !firebase.apps.length && firebase.initializeApp(FIREBASE_CONFIG);
      await this.firebaseSignIn(this.areaCode);
      this.setListeners();
    }
  }

  async firebaseSignIn() {
    if (this.areaCode) {
      const token = await Request('notification.customToken', {
        userAreaCode: this.areaCode
      });

      this.authToken = token;

      return firebase
        .auth()
        .signInWithCustomToken(token)
        .then((user) => (this.currentUser = user));
    }
  }
  // #endregion

  // #region listeners
  setListeners() {
    this.setUnreadNotificationListener();

    const events = Object.keys(EVENT_TYPE);

    events.forEach((event) => this.setNotificationListener(event));
  }

  setUnreadNotificationListener() {
    const ref = this.getNotificationsRef()
      .orderByChild('received')
      .equalTo(false)
      .limitToLast(MAX_NOTIFICATION_PER_PAGE);

    ref.on('child_added', this.addUnreadItem.bind(this));
    ref.on('child_removed', this.removeUnreadItem.bind(this));
  }

  setNotificationListener(event) {
    const ref = this.getNotificationsRef()
      .orderByChild('event')
      .equalTo(event)
      .limitToLast(MAX_NOTIFICATION_PER_PAGE);

    ref.on('child_added', this.addListItem.bind(this));
    ref.on('child_changed', this.replaceListItem.bind(this));
  }

  getNotificationsRef() {
    return this.getRef('notifications');
  }

  getRef(refName) {
    return firebase
      .database()
      .ref(`${refName}/${this.currentUser && this.currentUser.user.uid}`);
  }
  // #endregion

  // #region actions
  setItemProp(key, props) {
    this.getNotificationsRef().child(key).update(props);
  }

  setItemRead(key) {
    this.setItemProp(key, { read: true });
  }

  setItemsReceived() {
    while (Store.unreadNotificationsAmount !== 0) {
      Store.unreadNotifications.forEach((item) => {
        this.setItemProp(item.id, { received: true });
      });
    }
  }

  addUnreadItem(data) {
    const events = Object.keys(EVENT_TYPE);

    this.addItem(data, NOTIFICATION_TYPE.UNREAD, (item) =>
      events.includes(item.event)
    );
  }

  addListItem(data) {
    this.addItem(data, NOTIFICATION_TYPE.NORMAL);
  }

  addItem(data, type, condition = () => true) {
    const item = data.val();

    item.id = data.key;

    if (condition(item)) {
      Store[type] = item;
    }
  }

  removeUnreadItem(data) {
    this.removeItem(data.key, NOTIFICATION_TYPE.UNREAD);
  }

  removeItem(key, type) {
    Store[type] = Store[type].filter((item) => item.id !== key);
  }

  replaceListItem(data) {
    this.replaceItem(data, NOTIFICATION_TYPE.NORMAL);
  }

  replaceItem(data, type) {
    const items = Store[type];
    const index = items.findIndex((item) => item.id === data.key);

    const item = data.val();

    item.id = data.key;

    items[index] = item;
    Store[type] = items;
  }
  // #endregion
}

export default new NotificationService();
